import React from "react";
import BigTitle from "../../components/bigTitle/BigTitle";
import "./footer.css";

import logo from "../../assets/logo.svg";

const Footer = () => {
  return (
    <div className="gpt3__footer">
      <div className="gpt3__footer-titleContainer">
        <BigTitle
          modifier="center"
          title={["Do you want to step in to the future before others"]}
        />
        <a href="#">Request Early Access</a>
      </div>
      <div className="gpt3__footer-menuContainer">
        <div className="gpt3__footer-logoContainer">
          <img src={logo} />
          <p>
            Crechterwoord K12 182 DK
            <br />
            Alknjkcb, All Rights Reserved
          </p>
        </div>
        <div className="gpt3__footer-linksContainer">
          <div className="gpt3__footer-linksContainer-menu">
            <a href="#" className="mainlink">
              Links
            </a>
            <a href="#">Overons</a>
            <a href="#">Social Media</a>
            <a href="#">Counters</a>
            <a href="#">Contact</a>
          </div>
          <div className="gpt3__footer-linksContainer-menu">
            <a href="#" className="mainlink">
              Company
            </a>
            <a href="#">Terms & Conditions</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Contact</a>
          </div>
          <div className="gpt3__footer-linksContainer-menu">
            <a href="#" className="mainlink">
              Get in touch
            </a>
            <a href="#">Crechterwoord K12 182 DK Alknjkcb</a>
            <a href="#">085-132567</a>
            <a href="#">info@payme.net</a>
          </div>
        </div>
      </div>
      <div className="gpt3__footer-copyrightContainer">
        <p>© 2021 GPT-3. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
